import styled from 'styled-components';
import { Text15Light, Text16Regular } from '../../../components/utils/Text/Text.styles';
import { Button } from '../../../components/utils/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 42rem;
  padding: 2.4rem 0;

  @media only screen and (max-width: 760px) {
    height: 100%;
    padding: 1.6rem 1.2rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;

export const DescriptionText = styled(Text15Light)`
  line-height: 2.9rem;
  letter-spacing: -0.408px;
  margin-bottom: 2.4rem;
`;

export const Card = styled.div`
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  width: 100%;
  padding: 1.2rem;
  cursor: pointer;
`;

export const CardText = styled(Text16Regular)`
  line-height: 20px;
  letter-spacing: -0.408px;
`;

export const ContinueButton = styled(Button)`
  margin-top: 3rem;
  width: 24rem;
  margin-inline: auto;
`;
